import * as React from 'react';

import {Box, Stack, Typography,} from '@mui/material';

import AboutSection from './components/AboutSection';
import VideoSection from './components/VideoSection';
import Hero from './components/Hero';
import DownloadApps from './components/DownloadApps';
import HowItWorks from './components/HowItWorks';
import CustomFloatingButton from 'components/CustomFloatingButton';
import MarqueeCartHeader from 'components/MarqueeCartHeader';

export default function Home() {


  return (
    <Stack spacing={1}>

      <CustomFloatingButton/>

      <Hero/>

      <AboutSection />

      <Box sx={{ px: 1, py: 0 }}>
        <Typography variant="h4" sx={{ mx: 3, fontWeight:'bolder', color: '#F4136B' }}>Ingresa en:</Typography>
      </Box>
 
      <MarqueeCartHeader></MarqueeCartHeader>


      <DownloadApps></DownloadApps>

      <HowItWorks></HowItWorks>

      <VideoSection
        title="¿Que es Cardex Medico?"
        description="Mira este video para entender cómo llevamos tu historial médico escolar a la era digital."
        videoUrl="https://www.youtube.com/embed/D7sdioRDcoQ?si=6A1dpgzRcTj7yWqR"
      />


    </Stack>
  );
}